"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.declareConsent = declareConsent;
exports.getDeclaration = getDeclaration;
exports.getDeviceData = getDeviceData;
exports.getDeviceFile = getDeviceFile;
exports.getDevices = getDevices;
exports.getHanDevices = getHanDevices;
var _moment = _interopRequireDefault(require("moment"));
var _GermanDateHelpers = require("../../utils/GermanDateHelpers");
var _RestHelper = _interopRequireWildcard(require("../../utils/RestHelper"));
var _CacheHandler = _interopRequireDefault(require("../../utils/CacheHandler"));
var _config = _interopRequireDefault(require("../config/config"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function getDevices() {
  return _CacheHandler.default.requestCache(function () {
    return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/smartmeter/v0/meters"), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
  }, 'smartmeter');
}
function getHanDevices() {
  return _CacheHandler.default.requestCache(function () {
    return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/smartmeter/v0/meters?filterBy=hanEnabledDevices"), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
  }, 'smartmeter');
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getDeviceData(serialNumber, obises, fromDate, toDate) {
  var fromDateApi = (0, _moment.default)(fromDate, _GermanDateHelpers.DATE_FORMAT).format(_GermanDateHelpers.DATE_FORMAT_NATIVE);
  var toDateApi = (0, _moment.default)(toDate, _GermanDateHelpers.DATE_FORMAT).format(_GermanDateHelpers.DATE_FORMAT_NATIVE);
  if (!fromDateApi || !toDateApi) {
    throw new Error('Invalid date range');
  }
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/smartmeter/v0/meters/").concat(serialNumber, "/obises/").concat(obises, "?from=").concat(fromDateApi, "&to=").concat(toDateApi), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
}
function getDeclaration() {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/smartmeter/v0/consent"), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
}
function declareConsent(accepted) {
  return _RestHelper.default.put("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/smartmeter/v0/consent"), {
    agreed: accepted
  }, _RestHelper.default.setXClientHeader({
    headers: {
      'Content-Type': 'application/json'
    }
  }, _config.default.CHANNEL_CONFIG.portal));
}
function getDeviceFile(serialNumber, obises, fromDate, toDate) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/smartmeter/v0/meters/").concat(serialNumber, "/obises/").concat(obises, "/excel?from=").concat(fromDate, "&to=").concat(toDate), {}, _RestHelper.default.setXClientHeader({
    responseType: 'arraybuffer'
  }, _config.default.CHANNEL_CONFIG.portal));
}